import { connect } from 'react-redux';
import SellerReport from '../../components/seller/SellerReport';

const mapStateToProps = ({ report, user, salon, intl }) => ({
    showAppRecords: report.get('showAppRecords'),
    reportFilter: report.get('reportFilter'),
    isOwner: user.get('isOwner'),
    salon: user.get('salon'),
    showArchive: salon.get('showArchive'),
    currentLanguage: intl.get('locale') || intl.get('defaultLanguage'),
    enableArchive: salon.get('settings').enableArchive,
});

export default connect(mapStateToProps)(SellerReport);
